@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  <div class="flex align-items-center">
    @if ($.row && $.adata.fetch_key && $.row[$.adata.fetch_key] == 'success') {
      <i class="fa fa-circle text-green-500 mr-2"></i>
    }
    @if ($.row && $.adata.fetch_key && $.row[$.adata.fetch_key] == 'failed') {
      <i class="fa fa-circle p-error mr-2"></i>
    }
    <span class="uppercase">{{ $.row[$.adata.fetch_key] }}</span>
  </div>
}
